import { RLBaseService } from "./rl-base-service";
import * as Models from "../ts/rlAdmin.models";
export class VariesByCatalogService extends RLBaseService {
	static $inject = ["$resource", "$q"];

	selectedDimension: string = "";
	selectedFields: { [field: string]: boolean };

	constructor(private $resource: ng.resource.IResourceService, private $q: ng.IQService) {
		super($resource);
		this.selectedFields = {};
	}

	checkForVariesByCatalog(): boolean {
		var anyTrue = false;

		for (var field in this.selectedFields) {
			if (this.selectedFields[field]) {
				anyTrue = true;
			}
		}

		if (anyTrue) {
			return true;
		}
		else {
			if (this.selectedDimension != "") {
				return true;
			}
			else {
				return false;
			}
		}
	}

	clearSavedFields() {
		this.selectedDimension = "";
		this.selectedFields = {};
	}

	createVariedRights(variedFields: string[], collapseRights: boolean, parentEntityID: string, template: string, exclusiveCollection: { [key: number]: Models.ICharDatas }, nonExclusiveCollection: { [key: number]: Models.ICharDatas }, contactEntityIDs: string[]) {
		var data = {
			variedFields: variedFields,
			collapseRights: collapseRights,
			parentEntityID: parentEntityID,
			template: template,
			exclusiveCollection: exclusiveCollection,
			nonExclusiveCollection: nonExclusiveCollection,
			contactEntityIDs: contactEntityIDs
		};
		return this.toRLService<Models.IJobResponse>("/api/variedrights/createvariedrights").post(data).$promise;
	}
}